import type { ReactNode } from 'react';

/** Shared section heading for the experimental organizer workspace. */
export function OrganizerPanelHeading({ icon, children, actions }: {
  icon: ReactNode; children: ReactNode; actions?: ReactNode;
}) {
  return <div className="organizer-panel-heading">
    <span className="organizer-section__icon" aria-hidden="true">{icon}</span>
    <h2 className="organizer-panel-heading__title">{children}</h2>
    {actions && <div className="organizer-panel-heading__actions">{actions}</div>}
  </div>;
}
